export const INPUT_LABELS = {
    images: {
        allowedExtensions: '.jpg,.png,.gif',
        maxFiles: 1,
        invalidFileSizeMessage: "Uploaded file is too large. Maximum size is 7MB",
        maxFileSize: 7340032 // 5 MB
    }
}